export default {
  editDetailsTitle: 'Edit Details',
  cancel: 'Cancel',
  save: 'Save',
  uploadingFile: 'Uploading',
  loadingText: 'Loading...',
  noDataText: 'No documents available for this model',
  uploadDocument: 'Upload document',
  search: 'Search',
  headerName: 'Name',
  headerDetails: 'Details',
  headerSize: 'Size',
  headerCreated: 'Created',
  headerActions: 'Actions',
  download: 'Download',
  editDetails: 'Edit Details',
  delete: 'Delete',
  warningTitle: 'Warning',
  deleting: 'Deleting:',
  deleteConfirmation: 'This action cannot be undone. Are you sure?',
  fileEdited: 'File edited',
  deletingFile: 'Deleting file',
  fileDeleted: 'File deleted',
  uploadError: 'Error uploading file. Please remember that the only allowed file types are XLSX, PDF, and ZIP.'
}
